import type { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import axios from "axios";

const CURRENT_BASE_URL = "https://novagit.ir/api";

export abstract class HttpClient {
  private static instance: AxiosInstance;

  protected getInstance(): AxiosInstance {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- disable unnecessary condition
    if (!HttpClient.instance) {
      HttpClient.instance = axios.create({
        baseURL: CURRENT_BASE_URL,
        headers: {
          "Content-Type": "application/json",
        },
      });
      this.initializeInterceptors();
    }
    return HttpClient.instance;
  }

  private initializeInterceptors(): void {
    const handleResponse = (response: AxiosResponse) =>
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- disable unnecessary return
      this.handleResponse(response);
    const handleError = (error: AxiosError): Promise<AxiosError> =>
      this.handleError(error);
    HttpClient.instance.interceptors.response.use(handleResponse, handleError);
  }

  private handleResponse<T>(res: AxiosResponse<T>): AxiosResponse {
    return res;
  }

  private handleError(error: AxiosError): Promise<AxiosError> {
    return Promise.resolve(error);
  }
}
